import ReportLog from './ReportLog.component';

export default ReportLog;
